import { Switch as AriaSwitch } from "react-aria-components";
import { cx } from "@/utils/cx";

export interface FormRuleToggleProps {
	isSelected: boolean;
	onChange: (value: boolean) => void;
	"aria-label": string;
	isDisabled?: boolean;
	className?: string;
}

/**
 * Minimal accessible on/off switch tailored for the form rules list row.
 * Mirrors the existing brand palette without pulling in a heavier component.
 */
export function FormRuleToggle({
	isSelected,
	onChange,
	isDisabled,
	className,
	...rest
}: FormRuleToggleProps) {
	return (
		<AriaSwitch
			isSelected={isSelected}
			onChange={onChange}
			isDisabled={isDisabled}
			aria-label={rest["aria-label"]}
			className={cx(
				"group inline-flex items-center gap-2 outline-none focus-visible:ring-2 focus-visible:ring-brand-500 rounded-full",
				className,
			)}
		>
			<span
				className={cx(
					"relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full transition-colors",
					"group-selected:bg-brand-500 bg-bg-quaternary",
					"group-data-disabled:cursor-not-allowed group-data-disabled:opacity-50",
				)}
				aria-hidden
			>
				<span
					className={cx(
						"inline-block size-5 transform rounded-full bg-white shadow transition-transform",
						"translate-x-0.5 group-selected:translate-x-[22px]",
					)}
				/>
			</span>
		</AriaSwitch>
	);
}
